<template>
  <div class="dynamic-attr-text dynamic-attr-file" :class="(attrObj.isCheckError?'is-check-error':'')">
    <div
      :class="'dynamic-attr-text-title '+ (attrObj.mustFlag=='1'?'is-item-required':'')"
      :style="{width: $pScreen.textW,fontSize:$pScreen.titleS}"
    >
      <span>{{attrObj.title}}</span>
    </div>
    <div
      class="text-item-value"
      :style="{width: $pScreen.textW,fontSize:$pScreen.titleS, 'margin-bottom': attrObj.isCheckError ? '0' : '15px'}"
    >
      <ihlp-Upload
        ref="upload"
        :beforeUpload="importEvent"
        :format="['gif', 'jpg', 'jpeg', 'png']"
        accept="image/*"
        notAutoUpload
        v-model="channelFile"
        :max-size="5120"
      >
        <Button type="ghost" :class="{disabledBtn: attrObj.disabled}" :disabled="attrObj.disabled">
          <!-- {{$t('选择文件')}} -->
          <img style="width: 16px; vertical-align: middle;" src="static/runtime/images/magic/upload.png" alt>
          上传
        </Button>
      </ihlp-Upload>
      <div v-if="attrObj.isCheckError" class="errorTip">请上传附件</div>
    </div>
  </div>
</template>




<script>
export default {
  props: {
    attrObj: Object
  },
  data() {
    return {
      channelFile: [],
    };
  },
  created() {
    
  },
  //初始化后调用
  mounted: function() {
    this.channelFile = [{name: "aaa"}]
  },
  methods: {
    fileTypeChange(value) {
      //  this.attrObj.fileType=value
    },
    importEvent(file) {
      this.importUploadName = file.name;
      this.attrObj.channelFile = file;
    },
    addAttr() {
      this.attrObj.optionList.push({
        optionCode: "",
        optionContent: ""
      });
    },
    deleteAttr(index) {
      this.attrObj.optionList.splice(index, 1);
    },
    //关闭
    handleClose() {
      let tabItemName = this.$parent.name;
      this.$emit("handleClose", tabItemName);
    }
  }
};
</script>
<style>
  .disabledBtn{
    background: #f7f7f7 !important;
    color: #ccc !important;
  }
</style>




// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/dynamicAttr/file.vue